var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.largeHeader
    ? _c(
        "header",
        {
          staticClass: "d-flex align-items-center justify-content-between",
          attrs: { id: "header" },
        },
        [
          _c("ChatStats"),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "d-flex header-selection-main",
              staticStyle: { "align-items": "center", "margin-right": "30px" },
            },
            [
              _c(
                "div",
                {
                  staticClass: "d-flex header-selection-main",
                  staticStyle: { "align-items": "center" },
                },
                [
                  _vm.newVersionAvailable
                    ? _c(
                        "button",
                        {
                          directives: [
                            {
                              name: "tippy",
                              rawName: "v-tippy",
                              value: {
                                followCursor: true,
                                placement: "bottom-end",
                                theme: _vm.isDarkMode
                                  ? "light-border"
                                  : "google",
                              },
                              expression:
                                "{\n                followCursor: true,\n                placement: 'bottom-end',\n                theme: isDarkMode ? 'light-border' : 'google',\n            }",
                            },
                          ],
                          staticClass: "custom-version-btn",
                          attrs: { content: _vm.$t("message.newVersion") },
                          on: { click: _vm.reloadPage },
                        },
                        [
                          _c("NewVersionUpdate"),
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.$t("message.newVersionShort")) +
                              "\n            "
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              ),
              _vm._v(" "),
              _c(
                "md-button",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: {
                        followCursor: true,
                        placement: "bottom-end",
                        theme: _vm.isDarkMode ? "light-border" : "google",
                      },
                      expression:
                        "{\n                followCursor: true,\n                placement: 'bottom-end',\n                theme: isDarkMode ? 'light-border' : 'google',\n            }",
                    },
                  ],
                  staticClass: "custom-button",
                  attrs: { content: _vm.$t("message.errorReport") },
                  on: { click: _vm.makeBugReport },
                },
                [
                  _c(
                    "md-icon",
                    { style: { color: _vm.darkMode ? "yellow" : "black" } },
                    [_vm._v("report")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("HeaderRight"),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a-modal",
            {
              attrs: {
                id: "make-bug-report",
                footer: null,
                title: _vm.$t("message.sendErrorFeedBack"),
                visible: _vm.errorModalVisible,
              },
              on: {
                cancel: function ($event) {
                  _vm.errorModalVisible = false
                },
                ok: function ($event) {
                  _vm.errorModalVisible = false
                },
              },
            },
            [
              _c("ErrorReport", {
                attrs: { "file-url": _vm.errorFileURl },
                on: {
                  changeVisibility: function ($event) {
                    _vm.errorModalVisible = false
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }